module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCA0MCAxMiI+PGRlZnM+PHBhdGggaWQ9ImUyZDFhIiBkPSJNMTAzNCAyMzMuNzg1czIuMDE3LTExLjgxMiAxMi45NjgtMTEuNzg1YzguMDU2LjAxOCAxMC4zMTkgNS4xMjQgMTAuMzE5IDUuMTI0czQuNzM3LTIuNjkyIDkuMjkyLS44NTljNS45NCAyLjM5MSA2LjY0NyA3LjM4IDYuNjQ3IDcuMzggMC0uMDAxLTIyLjM5Ny4xNC0zOS4yMjYuMTQiLz48L2RlZnM+PGc+PGcgb3BhY2l0eT0iLjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDM0IC0yMjIpIj48dXNlIGZpbGw9IiNmZmYiIHhsaW5rOmhyZWY9IiNlMmQxYSIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/cloud-3.svg
// module id = 11
// module chunks = 0